/**
 * Form style helpers — copied from atlas-form-player/src/designer/styles/formStyles.ts
 * Returns theme-aware CSSProperties for common form elements
 */

import type React from 'react';

export type Theme = 'light' | 'dark';

export const getInputStyle = (theme: Theme = 'light'): React.CSSProperties => ({
  width: '100%',
  padding: '10px 12px',
  borderRadius: '6px',
  border: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.12)' : '#d1d5db'}`,
  background: theme === 'dark' ? 'rgba(0,0,0,0.3)' : '#fff',
  color: theme === 'dark' ? '#e5e7eb' : '#111827',
  fontSize: '14px',
  boxSizing: 'border-box',
  outline: 'none',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  fontFamily: 'inherit',
});

export const getLabelStyle = (theme: Theme = 'light'): React.CSSProperties => ({
  display: 'block',
  fontSize: '14px',
  fontWeight: 600,
  marginBottom: '6px',
  color: theme === 'dark' ? '#e5e7eb' : '#374151',
});

export const getButtonStyle = (
  variant: 'primary' | 'secondary' | 'danger' = 'primary',
  theme: Theme = 'light',
): React.CSSProperties => {
  const base: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '9px 18px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.15s, opacity 0.15s',
    fontFamily: 'inherit',
    lineHeight: 1.4,
  };

  if (variant === 'primary') {
    return {
      ...base,
      background: '#16a34a',
      color: '#fff',
    };
  }
  if (variant === 'danger') {
    return { ...base, background: '#ef4444', color: '#fff' };
  }
  // secondary
  return {
    ...base,
    background: theme === 'dark' ? 'rgba(255,255,255,0.08)' : '#f3f4f6',
    color: theme === 'dark' ? '#e5e7eb' : '#374151',
    border: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.12)' : '#d1d5db'}`,
  };
};

export const getFieldWrapperStyle = (): React.CSSProperties => ({
  marginBottom: 0,
  paddingTop: '4px',
});

export const getErrorStyle = (): React.CSSProperties => ({
  fontSize: '12px',
  color: '#ef4444',
  marginTop: '4px',
});

export const getHelpStyle = (theme: Theme = 'light'): React.CSSProperties => ({
  fontSize: '12px',
  color: theme === 'dark' ? '#64748b' : '#9ca3af',
  marginTop: '4px',
});
